/* tslint:disable */
import { Injectable } from '@angular/core';
import { HttpClient, HttpRequest, HttpResponse, HttpHeaders } from '@angular/common/http';
import { BaseService as __BaseService } from '../base-service';
import { ApiConfiguration as __Configuration } from '../api-configuration';
import { StrictHttpResponse as __StrictHttpResponse } from '../strict-http-response';
import { Observable as __Observable } from 'rxjs';
import { map as __map, filter as __filter } from 'rxjs/operators';

import { ActivateResponse } from '../models/activate-response';
import { ActivateQuoteDetailsResponse } from '../models/activate-quote-details-response';
import { BankDetailsResponse } from '../models/bank-details-response';
import { BankDetailsSaveResponse } from '../models/bank-details-save-response';
import { BankDetailsSaveRequest } from '../models/bank-details-save-request';
import { CoverDetailsResponse } from '../models/cover-details-response';
import { CoverDetailsSaveResponse } from '../models/cover-details-save-response';
import { CoverDetailsSaveRequest } from '../models/cover-details-save-request';
import { DeclineQuoteSaveRequest } from '../models/decline-quote-save-request';
import { PlanHolderDetailsResponse } from '../models/plan-holder-details-response';
import { SaveResponse } from '../models/save-response';
import { PlanHolderSaveRequest } from '../models/plan-holder-save-request';
import { VehicleDetailsResponse } from '../models/vehicle-details-response';
import { VehicleSaveRequest } from '../models/vehicle-save-request';
@Injectable({
  providedIn: 'root',
})
class ActivationControllerService extends __BaseService {
  static readonly activationV1ActivateGetPath = '/activation/v1/activate';
  static readonly activationV1ActivateQuoteDetailsGetPath = '/activation/v1/activate-quote-details';
  static readonly activationV1BankDetailsGetPath = '/activation/v1/bank-details';
  static readonly activationV1BankDetailsPutPath = '/activation/v1/bank-details';
  static readonly activationV1CoverDetailsGetPath = '/activation/v1/cover-details';
  static readonly activationV1CoverDetailsPutPath = '/activation/v1/cover-details';
  static readonly activationV1DeclineQuoteDetailsPutPath = '/activation/v1/decline-quote';
  static readonly activationV1PlanHolderDetailsGetPath = '/activation/v1/plan-holder-details';
  static readonly activationV1PlanHolderDetailsPutPath = '/activation/v1/plan-holder-details';
  static readonly activationV1QuoteScheduleGetPath = '/activation/v1/quote-schedule';
  static readonly activationV1SelectQuotePostPath = '/activation/v1/select-quote/{selectedQuote}';
  static readonly activationV1VehicleDetailsGetPath = '/activation/v1/vehicle-details';
  static readonly activationV1VehicleDetailsPutPath = '/activation/v1/vehicle-details';

  constructor(
    config: __Configuration,
    http: HttpClient
  ) {
    super(config, http);
  }

  /**
   * activationV1ActivateGet
   * @return OK
   */
  activationV1ActivateGetResponse(): __Observable<__StrictHttpResponse<ActivateResponse>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    let req = new HttpRequest<any>(
      'GET',
      this.rootUrl + `/activation/v1/activate`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<ActivateResponse>;
      })
    );
  }
  /**
   * activationV1ActivateGet
   * @return OK
   */
  activationV1ActivateGet(): __Observable<ActivateResponse> {
    return this.activationV1ActivateGetResponse().pipe(
      __map(_r => _r.body as ActivateResponse)
    );
  }

  /**
   * activationV1ActivateQuoteDetailsGet
   * @return OK
   */
  activationV1ActivateQuoteDetailsGetResponse(): __Observable<__StrictHttpResponse<ActivateQuoteDetailsResponse>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    let req = new HttpRequest<any>(
      'GET',
      this.rootUrl + `/activation/v1/activate-quote-details`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<ActivateQuoteDetailsResponse>;
      })
    );
  }
  /**
   * activationV1ActivateQuoteDetailsGet
   * @return OK
   */
  activationV1ActivateQuoteDetailsGet(): __Observable<ActivateQuoteDetailsResponse> {
    return this.activationV1ActivateQuoteDetailsGetResponse().pipe(
      __map(_r => _r.body as ActivateQuoteDetailsResponse)
    );
  }

  /**
   * activationV1BankDetailsGet
   * @return OK
   */
  activationV1BankDetailsGetResponse(): __Observable<__StrictHttpResponse<BankDetailsResponse>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    let req = new HttpRequest<any>(
      'GET',
      this.rootUrl + `/activation/v1/bank-details`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<BankDetailsResponse>;
      })
    );
  }
  /**
   * activationV1BankDetailsGet
   * @return OK
   */
  activationV1BankDetailsGet(): __Observable<BankDetailsResponse> {
    return this.activationV1BankDetailsGetResponse().pipe(
      __map(_r => _r.body as BankDetailsResponse)
    );
  }

  /**
   * activationV1BankDetailsPut
   * @param bankDetailsSaveRequest bankDetailsSaveRequest
   * @return OK
   */
  activationV1BankDetailsPutResponse(bankDetailsSaveRequest: BankDetailsSaveRequest): __Observable<__StrictHttpResponse<BankDetailsSaveResponse>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    __body = bankDetailsSaveRequest;
    let req = new HttpRequest<any>(
      'PUT',
      this.rootUrl + `/activation/v1/bank-details`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<BankDetailsSaveResponse>;
      })
    );
  }
  /**
   * activationV1BankDetailsPut
   * @param bankDetailsSaveRequest bankDetailsSaveRequest
   * @return OK
   */
  activationV1BankDetailsPut(bankDetailsSaveRequest: BankDetailsSaveRequest): __Observable<BankDetailsSaveResponse> {
    return this.activationV1BankDetailsPutResponse(bankDetailsSaveRequest).pipe(
      __map(_r => _r.body as BankDetailsSaveResponse)
    );
  }

  /**
   * activationV1CoverDetailsGet
   * @return OK
   */
  activationV1CoverDetailsGetResponse(): __Observable<__StrictHttpResponse<CoverDetailsResponse>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    let req = new HttpRequest<any>(
      'GET',
      this.rootUrl + `/activation/v1/cover-details`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<CoverDetailsResponse>;
      })
    );
  }
  /**
   * activationV1CoverDetailsGet
   * @return OK
   */
  activationV1CoverDetailsGet(): __Observable<CoverDetailsResponse> {
    return this.activationV1CoverDetailsGetResponse().pipe(
      __map(_r => _r.body as CoverDetailsResponse)
    );
  }

  /**
   * activationV1CoverDetailsPut
   * @param coverDetailsSaveRequest coverDetailsSaveRequest
   * @return OK
   */
  activationV1CoverDetailsPutResponse(coverDetailsSaveRequest: CoverDetailsSaveRequest): __Observable<__StrictHttpResponse<CoverDetailsSaveResponse>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    __body = coverDetailsSaveRequest;
    let req = new HttpRequest<any>(
      'PUT',
      this.rootUrl + `/activation/v1/cover-details`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<CoverDetailsSaveResponse>;
      })
    );
  }
  /**
   * activationV1CoverDetailsPut
   * @param coverDetailsSaveRequest coverDetailsSaveRequest
   * @return OK
   */
  activationV1CoverDetailsPut(coverDetailsSaveRequest: CoverDetailsSaveRequest): __Observable<CoverDetailsSaveResponse> {
    return this.activationV1CoverDetailsPutResponse(coverDetailsSaveRequest).pipe(
      __map(_r => _r.body as CoverDetailsSaveResponse)
    );
  }

  /**
   * activationV1DeclineQuoteDetailsPut
   * @param declineQuoteSaveRequest The reason code to be saved for declining a quote
   */
  activationV1DeclineQuoteDetailsPutResponse(declineQuoteSaveRequest: DeclineQuoteSaveRequest): __Observable<__StrictHttpResponse<null>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    __body = declineQuoteSaveRequest;
    let req = new HttpRequest<any>(
      'PUT',
      this.rootUrl + `/activation/v1/decline-quote`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<null>;
      })
    );
  }
  /**
   * activationV1DeclineQuoteDetailsPut
   * @param declineQuoteSaveRequest The reason code to be saved for declining a quote
   */
  activationV1DeclineQuoteDetailsPut(declineQuoteSaveRequest: DeclineQuoteSaveRequest): __Observable<null> {
    return this.activationV1DeclineQuoteDetailsPutResponse(declineQuoteSaveRequest).pipe(
      __map(_r => _r.body as null)
    );
  }

  /**
   * activationV1PlanHolderDetailsGet
   * @return OK
   */
  activationV1PlanHolderDetailsGetResponse(): __Observable<__StrictHttpResponse<PlanHolderDetailsResponse>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    let req = new HttpRequest<any>(
      'GET',
      this.rootUrl + `/activation/v1/plan-holder-details`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<PlanHolderDetailsResponse>;
      })
    );
  }
  /**
   * activationV1PlanHolderDetailsGet
   * @return OK
   */
  activationV1PlanHolderDetailsGet(): __Observable<PlanHolderDetailsResponse> {
    return this.activationV1PlanHolderDetailsGetResponse().pipe(
      __map(_r => _r.body as PlanHolderDetailsResponse)
    );
  }

  /**
   * activationV1PlanHolderDetailsPut
   * @param planHolderSaveRequest The details of the plan holder and primary driver to be saved
   * @return OK
   */
  activationV1PlanHolderDetailsPutResponse(planHolderSaveRequest: PlanHolderSaveRequest): __Observable<__StrictHttpResponse<SaveResponse>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    __body = planHolderSaveRequest;
    let req = new HttpRequest<any>(
      'PUT',
      this.rootUrl + `/activation/v1/plan-holder-details`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<SaveResponse>;
      })
    );
  }
  /**
   * activationV1PlanHolderDetailsPut
   * @param planHolderSaveRequest The details of the plan holder and primary driver to be saved
   * @return OK
   */
  activationV1PlanHolderDetailsPut(planHolderSaveRequest: PlanHolderSaveRequest): __Observable<SaveResponse> {
    return this.activationV1PlanHolderDetailsPutResponse(planHolderSaveRequest).pipe(
      __map(_r => _r.body as SaveResponse)
    );
  }

  /**
   * To get pdf document to view
   * @param quoteId quoteId
   */
  activationV1QuoteScheduleGet(): any {
    let uri: string = this.rootUrl + `/activation/v1/quote-schedule`;

    const headers: HttpHeaders = new HttpHeaders({
      'Accept': '*/*'
    });

    const options: any = {
      headers: headers,
      responseType: 'blob',
      observe: 'body'
    };

    return this.http.get(uri, options);

  }

  /**
   * Store selected quote and plan code
   * @param selectedQuote selectedQuote
   */
  activationV1SelectQuotePostResponse(selectedQuote: number): __Observable<__StrictHttpResponse<null>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;

    let req = new HttpRequest<any>(
      'POST',
      this.rootUrl + `/activation/v1/select-quote/${encodeURIComponent(String(selectedQuote))}`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<null>;
      })
    );
  }
  /**
   * Store selected quote and plan code
   * @param selectedQuote selectedQuote
   */
  activationV1SelectQuotePost(selectedQuote: number): __Observable<null> {
    return this.activationV1SelectQuotePostResponse(selectedQuote).pipe(
      __map(_r => _r.body as null)
    );
  }

  /**
   * activationV1VehicleDetailsGet
   * @return OK
   */
  activationV1VehicleDetailsGetResponse(): __Observable<__StrictHttpResponse<VehicleDetailsResponse>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    let req = new HttpRequest<any>(
      'GET',
      this.rootUrl + `/activation/v1/vehicle-details`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<VehicleDetailsResponse>;
      })
    );
  }
  /**
   * activationV1VehicleDetailsGet
   * @return OK
   */
  activationV1VehicleDetailsGet(): __Observable<VehicleDetailsResponse> {
    return this.activationV1VehicleDetailsGetResponse().pipe(
      __map(_r => _r.body as VehicleDetailsResponse)
    );
  }

  /**
   * activationV1VehicleDetailsPut
   * @param vehicleDetailsSaveRequest Vehicle details to save
   * @return OK
   */
  activationV1VehicleDetailsPutResponse(vehicleDetailsSaveRequest: VehicleSaveRequest): __Observable<__StrictHttpResponse<SaveResponse>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    __body = vehicleDetailsSaveRequest;
    let req = new HttpRequest<any>(
      'PUT',
      this.rootUrl + `/activation/v1/vehicle-details`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<SaveResponse>;
      })
    );
  }
  /**
   * activationV1VehicleDetailsPut
   * @param vehicleDetailsSaveRequest Vehicle details to save
   * @return OK
   */
  activationV1VehicleDetailsPut(vehicleDetailsSaveRequest: VehicleSaveRequest): __Observable<SaveResponse> {
    return this.activationV1VehicleDetailsPutResponse(vehicleDetailsSaveRequest).pipe(
      __map(_r => _r.body as SaveResponse)
    );
  }
}

module ActivationControllerService {
}

export { ActivationControllerService }
